import {
  PremedicationOrder,
  useCurrentPatientId,
  useDefaultQueryOptions,
  useDeletePremedicationMutation,
  useImportPremedicationFromProtocolMutation,
  usePremedicationsQuery,
  useSetNoPremedicationMutation,
  useUpsertPremedicationMutation
} from '@/modules/surgicalEvent';

export const useCurrentPremedications = () =>
  usePremedicationsQuery(useCurrentPatientId(), useDefaultQueryOptions());

export const useCurrentUpsertPremedication = () => {
  const currentParams = useCurrentPatientId();
  const [upsertPremedication, ...mutationProps] =
    useUpsertPremedicationMutation();

  async function handleUpsertPremedication(order: Partial<PremedicationOrder>) {
    return upsertPremedication({ ...currentParams, order }).unwrap();
  }

  return [handleUpsertPremedication, ...mutationProps] as const;
};

export const useCurrentDeletePremedication = () => {
  const currentParams = useCurrentPatientId();
  const [deletePremedication, ...mutationProps] =
    useDeletePremedicationMutation();

  async function handleDeletePremedication(orderId: string) {
    return deletePremedication({ ...currentParams, orderId });
  }

  return [handleDeletePremedication, ...mutationProps] as const;
};

export const useCurrentSetNoPremedication = () => {
  const currentParams = useCurrentPatientId();
  const [setNoPremedication, ...mutationProps] =
    useSetNoPremedicationMutation();

  async function handleSetNoPremedication(value: boolean) {
    return setNoPremedication({ ...currentParams, value }).unwrap();
  }

  return [handleSetNoPremedication, ...mutationProps] as const;
};

export const useCurrentImportPremedicationFromProtocol = () => {
  const currentParams = useCurrentPatientId();
  const [importFromProtocol, ...mutationProps] =
    useImportPremedicationFromProtocolMutation();

  async function handleImportFromProtocol(protocolId: string) {
    return importFromProtocol({ ...currentParams, protocolId }).unwrap();
  }

  return [handleImportFromProtocol, ...mutationProps] as const;
};
